import { render, staticRenderFns } from "./FormSafety.vue?vue&type=template&id=1ebb34c8"
import script from "./FormSafety.vue?vue&type=script&lang=js"
export * from "./FormSafety.vue?vue&type=script&lang=js"
import style0 from "./FormSafety.vue?vue&type=style&index=0&id=1ebb34c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports